import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "profileListingCardHeadDv" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "profileListingCardBodyDv" }
const _hoisted_4 = { class: "firstinfoListingCardDV" }
const _hoisted_5 = { class: "user_detail" }
const _hoisted_6 = {
  key: 1,
  style: {"height":"12px","margin-bottom":"4.25px"}
}
const _hoisted_7 = { class: "userName" }
const _hoisted_8 = {
  key: 1,
  class: "dummy-height"
}
const _hoisted_9 = { class: "infoCategory" }
const _hoisted_10 = {
  key: 1,
  class: "dummy-height"
}
const _hoisted_11 = {
  key: 0,
  class: "connection_buttons_wrapper"
}
const _hoisted_12 = { class: "btn btn--grayscale infoBohtDv" }
const _hoisted_13 = {
  key: 0,
  class: "btn btn--grayscale infoBohtDv"
}
const _hoisted_14 = { class: "secondinfoListingCardDV" }
const _hoisted_15 = {
  key: 0,
  class: "secondinfoListingCardDV"
}
const _hoisted_16 = { class: "firstDv" }
const _hoisted_17 = {
  key: 1,
  class: "secondinfoListingCardDV"
}
const _hoisted_18 = { class: "firstDv" }
const _hoisted_19 = { class: "labelDv" }
const _hoisted_20 = { class: "labelDv" }
const _hoisted_21 = { class: "statsLabel" }
const _hoisted_22 = {
  key: 2,
  class: "stockGridDv"
}
const _hoisted_23 = {
  key: 0,
  class: "stocksLength noStockContainer"
}
const _hoisted_24 = {
  key: 3,
  class: "stockGridDv"
}
const _hoisted_25 = {
  key: 0,
  class: "noStockContainer"
}
const _hoisted_26 = {
  key: 0,
  class: "profileListingCardfooterDv"
}
const _hoisted_27 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileAvatarComponent = _resolveComponent("ProfileAvatarComponent")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_ConnectionButton = _resolveComponent("ConnectionButton")!
  const _component_StockImageTag = _resolveComponent("StockImageTag")!

  return (_ctx.userData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleContainerClick && _ctx.handleContainerClick(...args))),
        class: _normalizeClass(["profileListingCardDv", {
      compact: _ctx.hideActions,
      'c-pointer':
        (!_ctx.fromInfluncersPopup || _ctx.fromExplore) || _ctx.onboardingCardFollowMode,
      frombuzz: _ctx.frombuzz,
      'profile-card--onboarding-selectable': _ctx.onboardingCardFollowMode,
      'profile-card--onboarding-following':
        _ctx.onboardingCardFollowMode && _ctx.userData.isFollowing,
      'profile-card--onboarding-busy':
        _ctx.onboardingCardFollowMode && _ctx.connectionActionLoading,
    }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              src: _ctx.images.coverPhoto,
              onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCoverPhotoError && _ctx.handleCoverPhotoError(...args))),
              crossorigin: "anonymous"
            }, null, 40, _hoisted_2)
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.images.profilePicture)
                ? (_openBlock(), _createBlock(_component_ProfileAvatarComponent, {
                    key: _ctx.images.profilePicture,
                    profileImage: _ctx.images.profilePicture,
                    border: true,
                    badges: false,
                    redirectProfile: !_ctx.suppressProfileNavigation,
                    class: _normalizeClass(["extramedium extraProfileDv", { xsmall: _ctx.isMobile }]),
                    style: {"margin-inline-end":"auto !important","margin-inline-start":"auto !important"},
                    onProfileClick: _ctx.goToProfile
                  }, null, 8, ["profileImage", "redirectProfile", "class", "onProfileClick"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6)),
              (_ctx.shouldShowNameTooltip)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 2,
                    class: "box-item",
                    effect: "dark",
                    content: _ctx.userData.fullName
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h2", {
                        ref: "fullName",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToProfile && _ctx.goToProfile(...args)), ["stop"]))
                      }, _toDisplayString(_ctx.formattedFullName), 513)
                    ]),
                    _: 1
                  }, 8, ["content"]))
                : (_openBlock(), _createElementBlock("h2", {
                    key: 3,
                    ref: "fullName",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToProfile && _ctx.goToProfile(...args)), ["stop"]))
                  }, _toDisplayString(_ctx.formattedFullName), 513))
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.userData.userName)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    style: {"color":"var(--base-light-text)"},
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToProfile && _ctx.goToProfile(...args)), ["stop"]))
                  }, " @" + _toDisplayString(_ctx.userData.userName), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_8))
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.userData.attribute)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    style: _normalizeStyle({ color: _ctx.attributeColor })
                  }, _toDisplayString(_ctx.$t(_ctx.getLabel(_ctx.userData.attribute))), 5))
                : (_openBlock(), _createElementBlock("p", _hoisted_10))
            ]),
            (_ctx.isCurrentUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("button", _hoisted_12, [
                    _createVNode(_component_IconComponent, {
                      class: "respondIconDv",
                      icon: "icon-you.svg"
                    }),
                    _createTextVNode(" (" + _toDisplayString(_ctx.$t("common.actions.you")) + ") ", 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.fromProfile && !_ctx.isCurrentUser && !_ctx.onboardingCardFollowMode)
              ? (_openBlock(), _createBlock(_component_ConnectionButton, {
                  key: 1,
                  profile: _ctx.userData,
                  onClick: _withModifiers(_ctx.preventProfileClick, ["stop"]),
                  onUpdateUserData: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('updateUserData')))
                }, null, 8, ["profile", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.fromUnBlock)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.isFollowingLoading)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_13, _cache[7] || (_cache[7] = [
                        _createElementVNode("div", { class: "loader" }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn--grayscale infoBohtDv",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.unBlockUsers && _ctx.unBlockUsers(...args)))
                      }, _toDisplayString(_ctx.$t("common.actions.unblock")), 1))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.hasSectionStats)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionStats, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "labelDv",
                        key: item.key
                      }, [
                        (_ctx.isOverflowingTwo)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 0,
                              class: "box-item",
                              effect: "dark",
                              content: item.label,
                              placement: "top-start"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("h2", {
                                  class: "statsLabel",
                                  ref_for: true,
                                  ref: "symbolElementTwo"
                                }, _toDisplayString(_ctx.formatStatLabel(item.key)), 513)
                              ]),
                              _: 2
                            }, 1032, ["content"]))
                          : (_openBlock(), _createElementBlock("h2", {
                              key: 1,
                              class: "statsLabel",
                              ref_for: true,
                              ref: "symbolElementTwo"
                            }, _toDisplayString(_ctx.formatStatLabel(item.key)), 513)),
                        _createElementVNode("p", null, _toDisplayString(_ctx.formatWithComma(_ctx.formatStatValue(item))), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h2", {
                        ref: "label",
                        class: "statsLabel"
                      }, _toDisplayString(_ctx.$t("common.common.followers")), 513),
                      _createElementVNode("p", null, _toDisplayString(_ctx.formatWithComma(_ctx.userData.followersCount)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("h2", _hoisted_21, _toDisplayString(_ctx.$t("common.common.following")), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.formatWithComma(_ctx.userData.followingCount)), 1)
                    ])
                  ])
                ])),
            (_ctx.hasStocks)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedStocks, (item) => {
                    return (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: item.stockId,
                      class: "box-item",
                      effect: "dark",
                      content: item.symbol?.toUpperCase(),
                      placement: "top-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_StockImageTag, {
                          class: "stocktag",
                          stockId: item.stockId,
                          imgUrl: item.logoUrl,
                          symbol: item.symbol,
                          market: item?.type?.toLowerCase(),
                          "disable-routing": _ctx.suppressProfileNavigation
                        }, null, 8, ["stockId", "imgUrl", "symbol", "market", "disable-routing"])
                      ]),
                      _: 2
                    }, 1032, ["content"]))
                  }), 128)),
                  (_ctx.hasAdditionalStocks)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, " +" + _toDisplayString(_ctx.additionalStocksCount), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (!_ctx.userData.stocks)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.userData.isFollowing ? "Add Friend" : "Follow") + " to View ", 1))
                    : (!_ctx.userData.stocks.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(4, (i) => {
                          return _createElementVNode("div", {
                            key: i,
                            class: "noStockContainer",
                            style: {"border":"none"}
                          })
                        }), 64))
                      : _createCommentVNode("", true)
                ]))
          ])
        ]),
        (_ctx.hasStocks)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", {
                class: _normalizeClass(["stock_stats secondinfoBodyDv", { 'f-gray': !_ctx.userData.stocks?.length }]),
                ref: "stocksRow"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockStatsData, (stat) => {
                  return (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: stat.title,
                    class: "box-item",
                    effect: "dark",
                    content: `${_ctx.$t(`common.common.${_ctx.$t(stat.title.toLowerCase())}`)}(${
              stat.count
            })`,
                    placement: "top-start"
                  }, {
                    default: _withCtx(() => [
                      (stat.maxWidth > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "stat",
                            style: _normalizeStyle({ maxWidth: stat.maxWidth + '%' })
                          }, [
                            _createElementVNode("div", {
                              class: "color",
                              style: _normalizeStyle({ background: stat.color })
                            }, null, 4)
                          ], 4))
                        : (_openBlock(), _createElementBlock("div", _hoisted_27))
                    ]),
                    _: 2
                  }, 1032, ["content"]))
                }), 128))
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}